/**
 * Created by wxb on 2023/07/21.
 */
import React, { PureComponent } from "react";
import { withRouter } from "react-router-dom";
import { Carousel, Button } from "antd";
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
class index extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            carouselNext: "0"
        };
        this.carouselref = React.createRef();
    }
    componentDidMount() {

    }
    render() {
        const { carouselNext } = this.state;
        const contentStyle = {
            height: '488px',
            color: '#fff',
            lineHeight: '488px',
            textAlign: 'center',
            background: '#fff',
            padding: "91px 260px 24px 260px",
            display: "flex"
        };
        const {
            match: { path },
            location: { pathname },
        } = this.props;
        return (
            <>
                <div>
                    <div style={{ height: 64 }}></div>
                    <div className={'zgh-coreProducts-card'} >
                        <p className="zgh-menu-title">核心产品</p>
                        <div className="zgh-coreProducts-card-body">
                            <div className="zgh-coreProducts-card-pic">
                                <div className="zgh-coreProducts-card-pic-details">
                                    <div className="zgh-coreProducts-card-pic-details-title">ISA全真互联数据工厂</div>
                                    <div className="zgh-coreProducts-card-pic-details-describe">将生产过程、生产关系、管理要求形成数据最小单元，通过解构、分析数据特征及需求，形成预测性生产及预测性管理的数据工厂。</div>
                                </div>
                            </div>
                            {/* <div className="zgh-coreProducts-coreIdeas">
                                <div className="zgh-coreProducts-card-coreIdeas" style={{ borderBottom: "0px solid #ccc", borderRight: "0px solid #ccc", }}>
                                    <div className="zgh-coreProducts-card-coreIdeas-title">最小数据颗粒</div>
                                    <div className="zgh-coreProducts-card-coreIdeas-describe">确保数据能用好用  面向工业生产海量数据，实现数据颗粒度最小化，保证数据质量和应用效率，形成“准确、高效、便捷”的数据服务。</div>
                                </div>
                                <div className="zgh-coreProducts-card-coreIdeas" style={{ borderBottom: "0px solid #ccc", borderRight: "0px solid #ccc" }}>
                                    <div className="zgh-coreProducts-card-coreIdeas-title">最小专业标准</div>
                                    <div className="zgh-coreProducts-card-coreIdeas-describe">盖最小生产过程  数字孪生产品以最小生产单元和最小生产过程的颗粒度，形成时空数据的精准记录与匹配。 </div>
                                </div>
                                <div className="zgh-coreProducts-card-coreIdeas" style={{ borderBottom: "0px solid #ccc" }}>
                                    <div className="zgh-coreProducts-card-coreIdeas-title">最小使用个体</div>
                                    <div className="zgh-coreProducts-card-coreIdeas-describe">数据分配适配个人需求</div>
                                </div>
                            </div>
                            <div className="zgh-coreProducts-coreIdeas">
                                <div className="zgh-coreProducts-card-coreIdeas" style={{ borderRight: "0px solid #ccc", }}>
                                    <div className="zgh-coreProducts-card-coreIdeas-title">最小数据切片</div>
                                    <div className="zgh-coreProducts-card-coreIdeas-describe">数据在最小时空的融合  数字孪生产品以最小生产单元和最小生产过程的颗粒度，形成时空数据的精准记录与匹配。 </div>
                                </div>
                                <div className="zgh-coreProducts-card-coreIdeas" style={{ borderRight: "0px solid #ccc", }}>
                                    <div className="zgh-coreProducts-card-coreIdeas-title">最小生产单元</div>
                                    <div className="zgh-coreProducts-card-coreIdeas-describe">实现精细化过程管控  数字孪生产品以最小生产单元和最小生产过程的颗粒度，形成时空数据的精准记录与匹配。 </div>
                                </div>
                                <div className="zgh-coreProducts-card-coreIdeas">
                                    <div className="zgh-coreProducts-card-coreIdeas-title">最小管理单元</div>
                                    <div className="zgh-coreProducts-card-coreIdeas-describe">满足精细动态管理</div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
                <div className="zgh-helpingBusinesses-card" id="helpingBusinesses">
                    <p className="zgh-menu-title">帮助企业</p>
                    <div className="zgh-helpingBusinesses-describe">以数据驱动工业</div>
                    <div className="zgh-helpingBusinesses-line" style={{ marginTop: 32 }}>
                        <div className="zgh-helpingBusinesses-detailsCard">
                            <div className="zgh-helpingBusinesses-detailsCard-icon">
                                <div className="icon-productionVisualization"></div>
                            </div>
                            <div className="zgh-helpingBusinesses-detailsCard-title">生产可视化</div>
                            <div className="zgh-helpingBusinesses-detailsCard-describe">生产过程全流程可视</div>
                        </div>
                        <div className="zgh-helpingBusinesses-detailsCard">
                            <div className="zgh-helpingBusinesses-detailsCard-icon">
                                <div className="icon-knowledgeBasedProduction"></div>
                            </div>
                            <div className="zgh-helpingBusinesses-detailsCard-title">生产知识化</div>
                            <div className="zgh-helpingBusinesses-detailsCard-describe">标准、经验、事件、管理转化为产线知识</div>
                        </div>
                        <div className="zgh-helpingBusinesses-detailsCard">
                            <div className="zgh-helpingBusinesses-detailsCard-icon">
                                <div className="icon-productionPrediction"></div>
                            </div>
                            <div className="zgh-helpingBusinesses-detailsCard-title">生产预测化</div>
                            <div className="zgh-helpingBusinesses-detailsCard-describe">生产过程提前预测，提早调整，准备预案</div>
                        </div>
                    </div>
                    <div className="zgh-helpingBusinesses-line">
                        <div className="zgh-helpingBusinesses-detailsCard">
                            <div className="zgh-helpingBusinesses-detailsCard-icon">
                                <div className="icon-knowledgeableProduction"></div>
                            </div>
                            <div className="zgh-helpingBusinesses-detailsCard-title">生产可知化</div>
                            <div className="zgh-helpingBusinesses-detailsCard-describe">生产过程异常精准感知</div>
                        </div>
                        <div className="zgh-helpingBusinesses-detailsCard">
                            <div className="zgh-helpingBusinesses-detailsCard-icon">
                                <div className="icon-productionStandardization"></div>
                            </div>
                            <div className="zgh-helpingBusinesses-detailsCard-title">生产标准化</div>
                            <div className="zgh-helpingBusinesses-detailsCard-describe">精细化各专业生产过程标准</div>
                        </div>
                        <div className="zgh-helpingBusinesses-detailsCard">
                            <div className="zgh-helpingBusinesses-detailsCard-icon">
                                <div className="icon-predictiveManagement"></div>
                            </div>
                            <div className="zgh-helpingBusinesses-detailsCard-title">管理预测化</div>
                            <div className="zgh-helpingBusinesses-detailsCard-describe">依托过程支持管理细分，多层级穿透式管理</div>
                        </div>
                    </div>
                </div>
                <div className="zgh-dataDrivenSystemEmpowersProduction">
                    {/* <p className="zgh-menu-title" style={{ paddingTop: 86 }}>数据化体系赋能生产</p>
                    <div className="zgh-dataDrivenSystemEmpowersProduction-card-scheme">
                        <div className="zgh-dataDrivenSystemEmpowersProduction-card">
                            <div className="zgh-dataDrivenSystemEmpowersProduction-title">产品数字孪生体系</div>
                            <div className="zgh-dataDrivenSystemEmpowersProduction-describe">形成各工序数字孪生产品，对生产过程进行最高</div>
                        </div>
                        <div className="zgh-dataDrivenSystemEmpowersProduction-card">
                            <div className="zgh-dataDrivenSystemEmpowersProduction-title">生产标准体系</div>
                            <div className="zgh-dataDrivenSystemEmpowersProduction-describe">生产过程精细拆分，分产品、工况、工艺段、来料等形成最小生产过程标准</div>
                        </div>
                    </div>
                    <div className="zgh-dataDrivenSystemEmpowersProduction-card-scheme">
                        <div className="zgh-dataDrivenSystemEmpowersProduction-card">
                            <div className="zgh-dataDrivenSystemEmpowersProduction-title">知识平台体系</div>
                            <div className="zgh-dataDrivenSystemEmpowersProduction-describe">记录事件案例，总结经验，分析优化形成知识留存，输出应用形成传承共享，减低人员流动风险</div>
                        </div>
                        <div className="zgh-dataDrivenSystemEmpowersProduction-card">
                            <div className="zgh-dataDrivenSystemEmpowersProduction-title">生产判定体系</div>
                            <div className="zgh-dataDrivenSystemEmpowersProduction-describe">利用标准和知识进行产品级，高精度匹配，形成问题精准定位与处置能力</div>
                        </div>
                    </div>
                    <div className="zgh-dataDrivenSystemEmpowersProduction-card-scheme">
                        <div className="zgh-dataDrivenSystemEmpowersProduction-card">
                            <div className="zgh-dataDrivenSystemEmpowersProduction-title">生产预测体系</div>
                            <div className="zgh-dataDrivenSystemEmpowersProduction-describe">生成过程通过数据化方法实现降本增效，通过产量和成本的双重保障，提升企业的核心竞争力</div>
                        </div>
                        <div className="zgh-dataDrivenSystemEmpowersProduction-card">
                            <div className="zgh-dataDrivenSystemEmpowersProduction-title">一贯制体系</div>
                            <div className="zgh-dataDrivenSystemEmpowersProduction-describe">在工序数据体系健全的基础上，构建一贯制体系，促进产品全流程管控与新产品研发，增加市场竞争优势</div>
                        </div>
                    </div> */}

                </div>
                <div className="zgh-dataDrivenPredictiveProduction">
                    <div className="zgh-dataDrivenPredictiveProduction-leftCard">
                        <div className="zgh-dataDrivenPredictiveProduction-title">数据驱动预测性生产</div>
                        <div className="zgh-dataDrivenPredictiveProduction-describe">以最小生产单元为载体，做到生产过程“可视、可知、可控、可预测”，实现“质量到点、能耗到坯、决策到人、成本到件”，达到生产预测化。</div>
                        <div className="zgh-dataDrivenPredictiveProduction-line">
                            <div className="zgh-dataDrivenPredictiveProduction-features">结合精细化的专业标准与知识</div>
                            <div className="zgh-dataDrivenPredictiveProduction-features">生产状态精确把控与感知</div>
                        </div>
                        <div className="zgh-dataDrivenPredictiveProduction-line">
                            <div className="zgh-dataDrivenPredictiveProduction-features">产品生产过程最小化管控</div>
                            <div className="zgh-dataDrivenPredictiveProduction-features">操作处置精准化指导与推荐</div>
                        </div>
                    </div>
                    <div className="zgh-dataDrivenPredictiveProduction-rightCard"></div>
                </div>
                <div className="zgh-dataDrivenPredictiveManagement">
                    <div className="zgh-dataDrivenPredictiveManagement-leftCard"></div>
                    <div className="zgh-dataDrivenPredictiveManagement-rightCard">
                        <div className="zgh-dataDrivenPredictiveManagement-title">数据驱动预测性管理</div>
                        <div className="zgh-dataDrivenPredictiveManagement-describe">将原有粗放管理梳理成可精确到具体过程的精益管理模式，实现管理“透明化、穿透化、预
                            测化”，帮助管理预判问题、高效感知问题、直击问题要点、动态响应管理要求。</div>
                        <div className="zgh-dataDrivenPredictiveManagement-line">
                            <div className="zgh-dataDrivenPredictiveManagement-features">透明化管理</div>
                            <div className="zgh-dataDrivenPredictiveManagement-features">以生产最小管理单元为基础，形成自动报表体系，达到管理透明化</div>
                        </div>
                        <div className="zgh-dataDrivenPredictiveManagement-line">
                            <div className="zgh-dataDrivenPredictiveManagement-features">预测化管理</div>
                            <div className="zgh-dataDrivenPredictiveManagement-features">建立数据化管理体系，实现可预测的动态管理</div>
                        </div>
                        <div className="zgh-dataDrivenPredictiveManagement-line">
                            <div className="zgh-dataDrivenPredictiveManagement-features">穿透化管理</div>
                            <div className="zgh-dataDrivenPredictiveManagement-features">管理指标逐层下钻分解，快速定位管理问题，实现管理穿透化</div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default withRouter(index)
